import React, { forwardRef } from 'react'
import { format } from '../../utils/number'
import { getDateTime } from '../../utils/date'

export const CustomCheckPrint = forwardRef(({ item, result, lend }, ref) => (
    <div style={{
        width: '80mm', // Standard thermal printer width
        maxWidth: '302px', // 80mm = ~302px at 96dpi
        margin: '0 auto',
        fontFamily: 'monospace', // Better for thermal printers
        fontSize: '12px',
        lineHeight: '1.2',
        color: '#000',
        backgroundColor: '#fff'
    }}>
        {console.log(item)}
        <div ref={ref} style={{ padding: '8px' }}>
            {/* Header */}
            <div style={{ textAlign: 'center', marginBottom: '12px' }}>
                <div style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    marginBottom: '4px',
                    letterSpacing: '1px'
                }}>
                    КОСМОС МОТОРС
                </div>

                <div style={{ fontSize: '14px', marginBottom: '2px', fontWeight: 'bold' }}>
                    Тел: (93) 888-99-22 (Бекзод)
                </div>
                <div style={{ fontSize: '14px', marginBottom: '8px', fontWeight: 'bold' }}>
                    Тел: (97) 309-43-48 (Ислом)
                </div>

                <div style={{
                    borderTop: '1px dashed #000',
                    margin: '8px 0'
                }} />
            </div>

            {/* Receipt Info */}
            <div style={{ marginBottom: '12px', fontSize: '11px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px', fontWeight: 'bold' }}>
                    <span style={{ fontWeight: 'bold' }}>Чек №:</span>
                    <span style={{ fontWeight: 'bold' }}>{item?.codeContent}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px', fontWeight: 'bold' }}>
                    <span style={{ fontWeight: 'bold' }}>Кассир:</span>
                    <span style={{ fontWeight: 'bold' }}>Бекзод</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px', fontWeight: 'bold' }}>
                    <span style={{ fontWeight: 'bold' }}>Клиент:</span>
                    <span style={{ fontWeight: 'bold' }}>{item?.client?.name}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px', fontWeight: 'bold' }}>
                    <span style={{ fontWeight: 'bold' }}>Дата:</span>
                    <span style={{ fontWeight: 'bold' }}>{getDateTime(new Date())}</span>
                </div>
                <div style={{
                    borderTop: '1px dashed #000',
                    margin: '8px 0'
                }} />
            </div>

            <div style={{ marginBottom: '12px' }}>
                {item?.products?.map((elem, i) => (
                    <div>
                        <div style={{ marginBottom: '8px', fontSize: '14px' }}>
                            <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>
                                {i + 1}. {elem?.name}
                            </div>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                paddingLeft: '12px'
                            }}>

                                <span style={{ fontWeight: 'bold' }}>
                                    {Number(elem?.quantity || 0)} x {format(
                                        item?.currency === 'sum'
                                            ? (item?.tradeType === 'wholesale' ? elem?.sumPriceTransfer : elem?.sumPriceSale) || 0
                                            : (item?.tradeType === 'wholesale' ? elem?.usdPriceTransfer : elem?.usdPriceSale) || 0
                                    )}
                                </span>
                                <span style={{ fontWeight: 'bold' }}>
                                    {format(Number(elem?.quantity || 0) * (
                                        item?.currency === 'sum'
                                            ? (item?.tradeType === 'wholesale' ? elem?.sumPriceTransfer : elem?.sumPriceSale) || 0
                                            : (item?.tradeType === 'wholesale' ? elem?.usdPriceTransfer : elem?.usdPriceSale) || 0
                                    ))}
                                </span>
                            </div>
                        </div>
                        <div style={{
                            borderTop: '1px dashed #000',
                            margin: '8px 0'
                        }} />
                    </div>
                ))}
            </div>

            {/* Total */}
            <div style={{ marginBottom: '12px' }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    marginBottom: '4px'
                }}>
                    <span>К ОПЛАТЕ:</span>
                    <span>{format(result)} {item.currency === 'sum' ? 'СУМ' : 'USD'}</span>
                </div>

                {(lend || item?.totalForOrderHistories) && (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        fontSize: '12px',
                        marginBottom: '4px'
                    }}>
                        <span>Сумма долга:</span>
                        <span>{format(lend || item?.totalForOrderHistories)} {item.currency === 'sum' ? 'СУМ' : 'USD'}</span>
                    </div>
                )}
            </div>
            {/* Footer */}
            <div style={{
                fontWeight: 'bold',
                textAlign: 'center',
                fontSize: '14px',
                marginTop: '16px',
                borderTop: '1px dashed #000',
                paddingTop: '8px'
            }}>
                <div>Спасибо за покупку!</div>
                <div style={{ marginTop: '4px' }}>
                    Приходите к нам еще!
                </div>
            </div>
        </div>
    </div>
))
